module.exports = __webpack_public_path__ + "img/tagTrue4.5b2077dd.png";